module.exports = __webpack_public_path__ + "img/Regenbogen.77df2d46.jpg";